import { Component, OnInit } from '@angular/core';
import { QuotationHistoryComponent } from '../../../page-quotation-cart/pages/quotation-history/quotation-history.component';

@Component({
    selector: 'app-page-quotations-list',
    templateUrl: './page-quotations-list.component.html',
    styleUrls: ['./page-quotations-list.component.scss'],
    standalone: true,
    imports: [QuotationHistoryComponent]
})
export class PageQuotationsListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
